
import { defineComponent, ref, reactive, toRefs, onMounted, computed, watch, nextTick } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import f10Api from '@/api/f10Api'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    token: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  components: { Table, Nodata },
  setup(props, context) {
    const pageData: any = reactive({
      pagination: {},
      total: 0,
      data: [],
      columns: [],
      spinning: true
    })
    pageData.pagination = computed(() => {
      return {
        total: pageData.total,
        showSizeChanger: true,
        showTotal: (total: any) => `共${pageData.total}条`,
        pageSizeOptions: ['10', '20', '50', '100'],
        onChange: changesize,
        onShowSizeChange: changesize
      }
    })
    pageData.columns = [
      {
        title: '截止日期',
        dataIndex: 'time',
        key: 'time',
        width: '100px',
        align: 'left'
      },
      // {
      //   title: '名次',
      //   dataIndex: 'Rank',
      //   key: 'Rank',
      //   width: '50px'
      // },
      {
        title: '股东名称',
        dataIndex: 'SHName',
        key: 'SHName',
        width: '120px',
        ellipsis: true,
        align: 'left',
        slots: { customRender: 'ellipsis' }
      },
      {
        title: '股东性质',
        dataIndex: 'SHNature',
        key: 'SHNature',
        width: '80px',
        ellipsis: true,
        align: 'left',
        slots: { customRender: 'ellipsis' }
      },
      {
        title: '股份类型',
        dataIndex: 'ShareType',
        key: 'ShareType',
        width: '90px',
        ellipsis: true,
        align: 'left',
        slots: { customRender: 'ellipsis' }
      },
      {
        title: '持股数(股)',
        dataIndex: 'HoldSum',
        key: 'HoldSum',
        width: '90px',
        align: 'right',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '占总股本比例',
        dataIndex: 'PCTOfFloatShares',
        key: 'PCTOfFloatShares',
        width: '110px',
        align: 'right',
        slots: { customRender: 'nocolorincrease' }
      },
      {
        title: '增减(股)',
        dataIndex: 'IncreaseOrReduce',
        key: 'IncreaseOrReduce',
        width: '85px',
        align: 'right',
        slots: { customRender: 'peopleCountColor' }
      },
      {
        title: '变动比例',
        dataIndex: 'ChangeRatio',
        key: 'ChangeRatio',
        width: '12%',
        align: 'right',
        slots: { customRender: 'increase' }
      },
      {
        title: '变动原因',
        dataIndex: 'ChangeReason',
        key: 'ChangeReason',
        width: '140px',
        ellipsis: true,
        align: 'left',
        slots: { customRender: 'ellipsis' }
      }
    ]
    const route = useRoute()
    function getData(PageID: number, PageSize: number) {
      const data: any = {}
      data.data = {
        Exch: route.query.market,
        Inst: route.query.code,
        PageID: PageID,
        PageSize: PageSize
      }
      data.headers = {
        token: props.token
      }
      f10Api.getholderholdchange(data).then((res: any) => {
        const data = JSON.parse(JSON.stringify(res.Data))
        if ((data.Detail || []).length) {
          data.Detail.forEach((item: any, i: number) => {
            item.index = 'HoldChange' + i
            item.time = item.EndDate ? window.moment(item.EndDate * 1000).format('YYYY-MM-DD') : '—'
          })
        }
        pageData.data = data.Detail
      })
    }
    getData(1, 10)
    function changesize(PageID: any, PageSize: any) {
      getData(PageID, PageSize)
      const dom: any = document.querySelector('.wrapper')
      const offsettop: any = document.getElementById('sdgdcgbd')?.offsetTop
      dom.scrollTop = offsettop
    }
    watch(
      () => (props.pageSourceData || {}).HoldChange,
      (val: any) => {
        const data = JSON.parse(JSON.stringify(val))
        if (data) {
          pageData.total = data.Total
        }
        nextTick(() => {
          pageData.spinning = false
        })
      },
      { deep: true }
    )
    return {
      ...toRefs(pageData)
    }
  }
})
